var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-grow-1 h-0 flex-column"},[_c('FdScroll',{attrs:{"x":"","y":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }